var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallHotel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 .5h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M4 4.5h16v16H4z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    d: "M16.02 13.92c.19 0 .392.081.55.24l1.524 1.532a.802.802 0 01.238.51.57.57 0 01-.157.445l-.08.082c-1.513 1.52-3.898 1.868-6.079.886l-.064-.029a10.211 10.211 0 01-5.068-5.095h0c-.993-2.23-.623-4.652.943-6.17.24-.233.648-.198.932.077l1.784 1.729a.79.79 0 01.25.557.56.56 0 01-.157.408l-.755.76c-.365.366-.399.972-.08 1.44l.133.198a12.15 12.15 0 002.987 3.064l.488.35c.47.337 1.082.31 1.455-.065l.756-.76a.558.558 0 01.4-.16"
  }))));
}
export default SvgCallHotel;